export default __webpack_public_path__ + "static/media/smile.ed8edf5d.png";